import {
    useContext,
} from 'react'

import DomainObjectContext from 'app/common/DomainObject/DomainObjectContext'

const useDomainObjectContext = () => {
    return useContext(DomainObjectContext)
}

export default useDomainObjectContext
